import React from "react";
import Modal from "react-modal";

export function StatusConfirmModal({ isOpen, statusTicket, onConfirm, onCancel }) {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Set as Out of Warranty"
      className="confirm-modal"
    >
      <form>
        <div className="card">
          <div className="card-header">Ticket Status</div>
          <div className="card-body">
            <div className="mb-3">Change status to {statusTicket}? </div>
            <button
              data-testid="confirm-status-ticket"
              type="button"
              className="btn btn-outline-primary mr-3"
              onClick={onConfirm}
            >
              Confirm
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
